var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"panel"},[_c('AnimationVisualizer',{staticStyle:{"margin-top":"0px","margin-left":"-153px"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"base"},[_c('h1',{staticClass:"lens"},[_c('h1',{staticClass:"reflections"})]),_c('h1',{staticClass:"animation"})])
}]

export { render, staticRenderFns }